module.exports = __webpack_public_path__ + "4cc6f3422183e2db66d4d45c4cba2240.pdf";